import { FormGroup } from '@angular/forms';
import { createPersonForm } from '@base/factories/person-form.factory';
import { createPaymentForm } from '@base/factories/payment-form.factory';
import { PersonFormModel } from '@base/models/form/person-form.model';
import { PaymentFormModel } from '@base/models/form/payment-form.model';
import { createGarantieProductForm, GarantieProductFormModel } from './garantie-product-form.factory';
import { createLegalCheckForm, GarantieLegalCheckFormModel } from './garantie-legal-check-form.factory';

export function createGarantieForm(): FormGroup<GarantieFormModel> {
  return new FormGroup<GarantieFormModel>({
    person: createPersonForm(),
    product: createGarantieProductForm(),
    payment: createPaymentForm(),
    legalCheck: createLegalCheckForm()
  });
}

export interface GarantieFormModel {
  person: FormGroup<PersonFormModel>;
  product: FormGroup<GarantieProductFormModel>;
  payment: FormGroup<PaymentFormModel>;
  legalCheck: FormGroup<GarantieLegalCheckFormModel>;
}

